import { LOAD_MANIFEST_INFO_REQUEST, LOAD_MANIFEST_INFO_RESPONSE } from '../constants/action-types'
import { handleResponse } from '../utils/response-utils'
import { getManifestInfoUrl } from '../utils/url-utils'

export const loadManifestInfoRequest = () => ({
  type: LOAD_MANIFEST_INFO_REQUEST
})

export const loadManifestInfoResponse = (response, error) => ({
  type: LOAD_MANIFEST_INFO_RESPONSE,
  payload: response,
  error
})

export const loadManifestInfo = () => dispatch => {
  dispatch(loadManifestInfoRequest())
  return fetch(getManifestInfoUrl(), {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json'
    }
  })
    .then(res => handleResponse(res))
    .then(data => dispatch(loadManifestInfoResponse(data, false)))
    .catch(error => dispatch(loadManifestInfoResponse(error, true)))
}



// WEBPACK FOOTER //
// ./src/actions/manifest-info-actions.js